import { ADAPModelValidator } from '../models/autogenerated';

export function getValidationAsString(validation: ADAPModelValidator): string {
  return `${validation.entityDescription}: ${validation.errors.join(', ')}`;
}
